function C404(props) {
  return (
    <div className="c404">
      <h2>404</h2>
    </div>
  );
}

export default C404;
